import { render, staticRenderFns } from "./ArtikelUbersichtTable.vue?vue&type=template&id=e24e984a&scoped=true&"
import script from "./ArtikelUbersichtTable.vue?vue&type=script&lang=js&"
export * from "./ArtikelUbersichtTable.vue?vue&type=script&lang=js&"
import style0 from "./ArtikelUbersichtTable.vue?vue&type=style&index=0&id=e24e984a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24e984a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VDataTable,VDialog,VIcon,VSpacer,VToolbar,VToolbarTitle,VTooltip})
